export const DailyReport = () => {
  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <h1 className="m-0">Daily Report</h1>
        </div>
      </div>
      <div className="content">
        <div className="container-fluid">Daily report content goes here</div>
      </div>
    </div>
  );
};

export default DailyReport;
